const genFragmentShader = (mapResolutionIVec2Value) => `
  varying vec2 vUv;
  uniform sampler2D map;
  uniform vec3 color;
  uniform float opacity;
  uniform float alphaTest;
  uniform float blend;
  void main() {
    ivec2 resInt = ${mapResolutionIVec2Value};
    vec2 res = vec2(resInt);
    vec2 resRec = 1.0 / res;

    vec2 vUv11 = floor(vUv * res) * resRec;
    vec2 vUv22 = vUv11 + resRec;

    vec2 vUv21 = vec2(vUv22.r, vUv11.g);
    vec2 vUv12 = vec2(vUv11.r, vUv22.g);

    vec4 sampledDiffuseColor11 = texture2D(map, vUv11);
    vec4 sampledDiffuseColor12 = texture2D(map, vUv12);
    vec4 sampledDiffuseColor21 = texture2D(map, vUv21);
    vec4 sampledDiffuseColor22 = texture2D(map, vUv22);

    vec2 tXY = (vUv - vUv11) / resRec;

    vec4 sampledDiffuseColor1 = mix(sampledDiffuseColor11, sampledDiffuseColor12, tXY.y);
    vec4 sampledDiffuseColor2 = mix(sampledDiffuseColor21, sampledDiffuseColor22, tXY.y);
    
    vec4 sampledDiffuseColor = mix(sampledDiffuseColor1, sampledDiffuseColor2, tXY.x);
    
    gl_FragColor = vec4(color * sampledDiffuseColor.r * blend, max(0.0, (1.0 - (sampledDiffuseColor.r + sampledDiffuseColor.g + sampledDiffuseColor.b) / alphaTest)) * opacity);

    #include <tonemapping_fragment>
    #include <colorspace_fragment>
  }`;


export const FRAGMENT_SHADER = genFragmentShader('textureSize(map, 0)');

export const genFragmentShaderConstMapSize = (mapSizeX, mapSizeY) => genFragmentShader(`ivec2(${mapSizeX}, ${mapSizeY})`);
